import { isAxiosError } from 'axios'

interface FastApiValidationError {
  loc: (string | number)[]
  msg: string
  type: string
}

interface FastApiErrorBody {
  detail?: string | FastApiValidationError[]
}

/** Normaliza los formatos de error de FastAPI (str, lista de validación, red) a un mensaje legible. */
export function getApiErrorMessage(error: unknown, fallback = 'Ocurrió un error inesperado.'): string {
  if (isAxiosError<FastApiErrorBody>(error)) {
    if (!error.response) {
      return 'No fue posible contactar al servidor. Verifica tu conexión.'
    }

    const detail = error.response.data?.detail
    if (typeof detail === 'string') {
      return detail
    }
    if (Array.isArray(detail) && detail.length > 0) {
      return detail.map((issue) => issue.msg).join(' ')
    }
    return fallback
  }

  if (error instanceof Error) {
    return error.message
  }

  return fallback
}
